import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../profile/profile.css";

const UserProfile = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(`https://vortexnetowrknew.co.uk/php-backend/get_user.php?id=${id}`);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        
        const data = await res.json(); // parse JSON
        setUser(data.user || null); // use parsed JSON
      } catch (err) {
        console.error("Error loading user:", err);
      }
    };

    fetchUser();
  }, [id]);

  if (!user) return <div className="user-profile">Loading...</div>;

  return (
    <div className="user-profile">
      <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
      <div className="profile-card">
        <i className="fa-solid fa-user-circle"></i>
        <h2>{user.username}</h2>
        <p><strong>Email:</strong> {user.email}</p>
        <p><strong>Joined:</strong> {user.joined_at}</p>
      </div>
    </div>
  );
};

export default UserProfile;
